import React from "react";
import { MembersTable } from "../../components/members_components/members_table";
import "./members_list.css";

export default function MembersList(props) {
  return <MembersTable {...props} />;
}
